const getStatisticHeader = (statistic) => {
  switch (statistic) {
    case "realReach":
      return "real reach";
    case "effectiveEr":
      return "effective er";
    case "piecesOfContent":
      return "pieces of content";
    case "watchedFullVideo":
      return "watched full video";
    case "creatorsEngaged":
      return "creators engaged";
    case "linkClicks":
      return "link clicks";
    case "stickerTaps":
      return "sticker taps";
    case "impressionsToFollowers":
      return "\nimpressions to followers";
    case "reachToFollowers":
      return "\nreach to followers";
    case "videoViews":
      return "video views";
    case "fullVideoViews":
      return "full video views";
    case "minutesWatched":
      return "\n estimated minutes watched";
    case "avgViewPercentage":
      return "\n avg percentage viewed";
    case "sentimentPositiveShare":
      return "positive sentiment\n percentage";
    case "sentimentNeutralShare":
      return "neutral sentiment\n percentage";
    case "sentimentNegativeShare":
      return "negative sentiment\n percentage";
    case "sentimentProductRelatedShare":
      return "product related\n comments percentage";
    case "realReachToFollowers":
      return "real reach to followers";
    case "mediaRepostCount":
      return "reposts";

    default:
      return statistic;
  }
};

const getTooltipMetricName = (statistic) => {
  switch (statistic) {
    case "vr":
      return "views";
    case "impressionsToFollowers":
      return "impressions";
    case "reachToFollowers":
      return "real reach";
    default:
      return "[name]";
  }
};

export { getStatisticHeader, getTooltipMetricName };
